// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"80ac76e0","147":"b5c0e329","332":"dbba6083","417":"52ec85ad","655":"918a99db","727":"237c6849","747":"67fc7433","914":"8af7f76e","956":"7da60517","997":"fdca2de3"}[chunkId] + ".chunk.js";
};